<template>
  <div id="app">
    <router-view />
    <!-- <img id="btn"
         src="./assets/img/bdbtn.png"
         @click="go" /> -->
    <!-- <img id="btn2"
         src="./assets/img/btn2.png"
         @click="gohhh" /> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    go () {
      window.location.href = 'https://m.liangpinedu.cn/special/eventsgd/index.html?n=20210516jdyx#gwzxbmldy'
    },
    gohhh () {
      window.location.href =
        'https://mp.weixin.qq.com/s/3MsmZW457IsrWYVe3z_Icw'
    }
  }
}
</script>

<style>
@import url('../src/assets/css/base.css');
#app {
  width: 100%;
  height: 100%;
}
  #btn {
    position: fixed;
    top: 500px;
    right: 30px;
  }
    #btn2 {
    position: fixed;
    top: 500px;
    left: 30px;
    width: 150px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue